/* Supply the Shopify product photo to Judge.me's native review form. */
(() => {
  const connected = new WeakSet();
  function prepare() {
    document.querySelectorAll('[data-mh-review-product-image]').forEach(widget => {
      if (connected.has(widget)) return;
      connected.add(widget);
      const sync = () => {
        const image = widget.dataset.mhReviewProductImage;
        if (!image) return;
        widget.querySelectorAll('.jdgm-rev-widg, .jm-review-widget').forEach(inner => {
          if (!inner.getAttribute('data-image-url')) inner.setAttribute('data-image-url', image);
        });
      };
      sync();
      // The app renders lazily and may replace the widget when paging reviews.
      new MutationObserver(sync).observe(widget, { childList: true, subtree: true });
    });
  }
  prepare();
  document.addEventListener('shopify:section:load', prepare);
})();
